<template name="deviceList">
  <div>
    <!-- 项目列表组件 -->
    <div v-if="show==1">
      <div class="button-group-card">
        <div class="button-group-title">
          <el-button type="primary" :plain="true" shape="circle" @click="addDevice" icon="el-icon-edit">
            添加新设备
          </el-button>
        </div>
      </div>
      <!-- 搜索部分 -->
      <div style="display: flex;justify-content: center;">
        <el-input style="width: 60%;margin-right: 10px"
                  placeholder="输入设备名称搜索"
                  v-model="searchTitle"
                  clearable>
        </el-input>
        <el-button icon="el-icon-search" circle @click="getDeviceList"></el-button>
      </div>
      <div style="margin-top: 10px;">
        <el-table :data="deviceList" style="width: 100%;text-align: center; height: 100%; " border ref="refTable"
                  :header-cell-style="{ background: '#F2F2F2', color: '#333' }">
          <el-table-column prop="id" label="id" width="40" show-overflow-tooltip align="center"/>
          <el-table-column prop="deviceName" label="设备名称" width="200" show-overflow-tooltip align="center"/>
          <el-table-column prop="description" label="设备描述" width="200" show-overflow-tooltip align="center"/>
          <el-table-column prop="sn" label="设备序列号" min-width="150" show-overflow-tooltip align="center"/>
          <el-table-column prop="bindTime" label="设备绑定时间" min-width="150" show-overflow-tooltip align="center"/>
          <el-table-column fixed="right" label="修改" width="100" align="center">
            <template v-slot="scope">
              <el-button @click="handleEditIdBtnClick(scope.row)" type="primary" size="small">修改</el-button>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="详情" width="100" align="center">
            <template v-slot="scope">
              <el-button @click="deleteIndex = scope.row; deleteDialogVisible = true;" type="primary" size="small">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <el-dialog title="修改设备名称和描述" :visible.sync="nameShow">
        <el-form>
          <el-form-item label="设备名称" label-width="120px">
            <el-input v-model="tempTitle" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="设备描述" label-width="120px">
            <el-input v-model="tempDescription" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="设备序列号" label-width="120px">
            <el-input v-model="tempSn" autocomplete="off" disabled></el-input>
          </el-form-item>
          <el-form-item label="设备绑定时间" label-width="120px">
            <el-input v-model="tempBindTime" autocomplete="off"  disabled></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="nameShow=false">取 消</el-button>
          <el-button type="primary" @click="handleConfirmBtnClick();nameShow=false">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 添加新项目组件 -->
    <div v-if="show==2">
      <div class="content">
        <div class="info-card">
          <el-form>
            <el-form-item label="设备名称" label-width="120px">
              <el-input v-model="deviceName" autocomplete="off"></el-input>
            </el-form-item>
          </el-form>

        </div>

        <div class="info-card">
          <el-form>
            <el-form-item label="设备描述" label-width="120px">
              <el-input v-model="description" autocomplete="off"></el-input>
            </el-form-item>
          </el-form>
        </div>

        <div class="info-card">
          <el-form>
            <el-form-item label="设备序列号" label-width="120px">
              <el-input v-model="deviceSn" autocomplete="off"></el-input>
            </el-form-item>
          </el-form>
        </div>

        <div class="button-group-card">
          <div class="button-group-title">
            <el-button type="success" @click="handleConfirmAdd" :plain="true">确认新增</el-button>
          </div>
        </div>
        <div class="button-group-card">
          <div class="button-group-title">
            <el-button type="primary" @click="show=1" :plain="true">返回设备列表</el-button>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
        title="提示"
        :visible.sync="addDialogVisible"
        width="30%"
    >
      <span>确定新增？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible=false;">取 消</el-button>
        <el-button type="primary" @click="confirmAdd">确 定</el-button>
     </span>
    </el-dialog>
    <el-dialog
        title="提示"
        :visible.sync="deleteDialogVisible"
        width="30%"
    >
      <span>确定删除？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialogVisible=false;">取 消</el-button>
        <el-button type="primary" @click="deleteCommit">确 定</el-button>
     </span>
    </el-dialog>
  </div>
</template>

<script>
import API from "@/../config/api.js";
export default {
  name: "deviceList",
  data() {
    return {
      deviceList: [],
      userId: '',
      customStyle: {
        color: '#3399ff',
      },
      customStyle3: {
        color: '#55aa00',
      },
      customStyle4: {
        color: '#aa55ff',
      },
      tempTitle: '', //记录修改框里出现的名称，传入后端
      tempDeviceId: 0,
      nameShow: false, //修改项目和描述
      tempDescription: '',   //修改框里出现的描述，传到后端
      tempSn:'',//修改框里面的序列号,只显示不修改
      tempBindTime:'',//修改框里面的绑定时间,只显示不修改
      searchTitle: '',       //搜索的项目名称

      show: 1,  //页面上两个组件的切换
      // showFoot: false,
      deviceName: '',    //新增设备名字
      description: '',   //新增描述
      deviceSn: '',   //新增设备序列号
      deleteIndex: -1,//要删除的设备序号
      deleteDialogVisible: false,
      addDialogVisible: false,
    }
  },
  //此处定义传入的数据
  props: {
    companyId: Number,
  },
  mounted: function () {
    this.userId = window.localStorage.getItem('userid');
    console.log('公司一级项目管理userId的值=', this.userId);
    console.log(this.companyId)
    // 获取该公司全部的一级项目
    this.deviceList = []
    this.getDeviceList();
    this.show = 1;
  },
  methods: {
    //修改设备名字和描述
    handleEditIdBtnClick(item) {
      console.log(item)
      this.nameShow = true
      this.tempTitle = item.deviceName
      this.tempDescription = item.description
      this.tempDeviceId = item.id
      this.tempSn = item.sn
      this.tempBindTime = item.bindTime;
      console.log('this.tempDeviceId', this.tempDeviceId)
    },
    // 获取当前公司所有的设备，已经调通
    getDeviceList() {
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }

      let data = {
        companyId: this.companyId,
        deviceName:this.searchTitle
      }
      console.log(data)
      this.$axiosRequest({
        url: API.getDeviceList,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          console.log(res.data)
          this.deviceList = res.data["deviceList"]

        }
      });
    },
    //新增设备前
    handleConfirmAdd(){
      if (this.deviceName != '' && this.description != '' && this.deviceSn != '') {
        this.addDialogVisible=true
      } else if (this.deviceName == '') {
        this.$message({
          message: '设备名称不能为空',
          type: 'warning'
        })
      }else if(this.description == ''){
        this.$message({
          message: '设备描述不能为空',
          type: 'warning'
        })
      } else if(this.deviceSn == ''){
        this.$message({
          message: '序列号不能为空',
          type: 'warning'
        })
      }


    },
    //修改设备名字和描述与后端
    // async
    handleConfirmBtnClick() {
      if (!this.tempTitle) {
        this.$message({
          message: '设备名不能为空',
          type: 'error'
        })
        this.nameShow = false
        return
      }
      if (!this.tempDescription) {
        this.$message({
          message: '描述不能为空',
          type: 'error'
        })
        this.nameShow = false
        return
      }
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }
      let data = {
        companyId: this.companyId,
        id: this.tempDeviceId,           //设备id
        deviceName: this.tempTitle,
        description: this.tempDescription
      }
      this.$axiosRequest({
        url: API.updateDevice,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          if (res.data > 0) {
            this.$message({
              message: '修改成功',
              type: 'success'
            });
            for (let i = 0; i < this.deviceList.length; i++) {
              if (this.deviceList[i].id == this.tempDeviceId) {
                this.deviceList[i].deviceName = this.tempTitle
                this.deviceList[i].description = this.tempDescription
                break;
              }
            }
            this.nameShow = false;
            this.$emit('changeName', this.tempTitle, this.tempDeviceId)  //向外抛出修改名字的事件，后面要对变量下边的设备变量下面的设备名进行联动
          } else if (res.data == 0) {
            this.$message({
              message: '设备名称已经存在',
              type: 'error'
            });
            this.nameShow = false
            return
          } else if (res.data == -2) {
            this.$message({
              message: '参数错误',
              type: 'error'
            });
            this.nameShow = false
            return
          } else if (res.data == -1) {
            this.$message({
              message: '程序错误',
              type: 'error'
            });
            this.nameShow = false
            return
          }

        }
      });
    },

    //删除设备
    deleteCommit() {
      this.deleteDialogVisible = false;
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }
      let data = {
        companyId: this.companyId,
        id: this.deleteIndex.id,                 //设备的id
      }
      this.$axiosRequest({
        url: API.deleteDevice,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          if (res.data.flag == "true") {
            this.$message({
              message: res.data.info,
              type: 'success'
            });
            this.getDeviceList();
            //后期根据接口重新修改
            let delChild = {
              label: this.deleteIndex.deviceName,
              stageType: 2,
              id: this.deleteIndex.id,
              uniqueId: 'Device_' + this.deleteIndex.id
            };
            console.log('eeeeeee', delChild)
            this.$emit('delete', delChild);

          } else if (res.data.flag == "false") {
            this.$message({
              message: res.data.info,
              type: 'none'
            });
          }
        }
      });
    },
    //清空搜索
    clear() {
      this.searchTitle = '';
      this.getDeviceList();
    },
    //创建新的设备
    addDevice() {
      this.show = 2;
    },
    confirmAdd() {
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }

      let newDevice = {
        deviceName: this.deviceName,
        description: this.description,
        companyId: this.companyId,
        sn: this.deviceSn
      }

      this.$axiosRequest({
        url: API.addDevice,
        method: 'POST',
        data: newDevice,
        header: header,
        success: res => {
          if (res.data > 0) {
            this.$message({
              message: '新增设备成功',
              icon: 'none'
            });
            //后期根据接口重新修改，要打开、
            let newChild = { //后期删掉
              label: this.deviceName,
              stageType: 12,
              id: res.data, //应该是后端返回的id值
              children: [],
              uniqueId: 'Device_' + res.data
            }
            console.log('eeeeeeeee', res.data)
            this.deviceList = [] //清空本组件页面在show=1的时候原本的项目列表
            this.searchTitle = '';  //清空搜索的位置
            this.getDeviceList(); //重新从后端获取
            this.show = 1;
            this.$emit('add', newChild);   //后面需要打开联动
          } else if (res.data == 0) {
            this.$message({
              message: '设备名称重复',
              icon: 'none'
            });
            return;
          } else if (res.data == -3) {
            this.$message({
              message: '设备不存在',
              icon: 'none'
            });
            return;
          } else if (res.data == -4) {
            this.$message({
              message: '当前设备已经被添加过了',
              icon: 'none'
            });
            return;
          } else if (res.data == -2) {
            this.$message({
              message: '参数出错',
              icon: 'none'
            });
            return;
          } else if (res.data == -1) {
            this.$message({
              message: '程序错误',
              icon: 'none'
            });
            return;
          }
        }
      });
    },
    commitDelete() {

    },
    //
    //确认新增设备
  },
}
</script>

<style>
.button-group-card {
  margin: 10px 15px 10px 15px;
  padding: 12px;
}

.row-line {
  line-height: 20px;
}

.info-title {
  font-size: 18px;
  font-weight: bold;
  color: #004768;
  font-family: '仿宋';
}

.info-content {
  font-size: 18px;
  font-family: '仿宋';
}

.button-group-title {
  font-size: 18px;
  font-weight: bold;
}

.info-card {
  margin: 10px 15px 10px 15px;
  padding: 12px;
  background-color: rgba(240, 240, 240, 0.7);
}

.info-content {
  margin: 10px 0px 10px 10px;
  height: auto;
}

.title-style {
  font-size: 18px;
  font-weight: bold;
}

.title2-style {
  font-size: 15px;
  line-height: 40px;
}

.title3-style {
  font-size: 14px;
  line-height: 40px;
}

.btn {
  margin-left: 80px;

}

.user-info-content {
  font-weight: bold;
}

.info-content {
  margin: 10px 0px 10px 10px;
  height: auto;
}

.title-style {
  font-size: 18px;
  font-weight: bold;
}

.title2-style {
  font-size: 15px;
  font-weight: bold;
  line-height: 40px;
}

.button-group-card {
  margin: 10px 15px 10px 15px;
  padding: 12px;
}
</style>